// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.banner-title[data-v-4c3d30e0] {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 20px 0px;\n  color: rgb(83, 83, 83);\n}\n.no-comment[data-v-4c3d30e0] {\n  position: relative;\n  color: #666;\n  text-align: center;\n  top: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
